import React from "react"
import PropTypes from "prop-types"
import Icon from "@kit/design/icon"

const Download = props => {
  Download.propTypes = {
    path: PropTypes.string.isRequired
  }

  return (
    <a
      href={props.path}
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold ml-2 text-sm flex flex-row justify-between items-center self-center hover:bg-gray-100 cursor-pointer rounded-lg py-1 px-2 hover:no-underline"
    >
      <Icon name="download" />
      <span className="ml-2">Download</span>
    </a>
  )
}

const Action = props => {
  Action.propTypes = {
    action: PropTypes.object.isRequired,
    message: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  }

  let type

  switch (props.action.type) {
    case "download":
      type = <Download {...props.action} />
  }

  return (
    <li className="py-2 px-4 flex flex-auto action" data-status={props.status}>
      <span className="message flex flex-row flex-auto text-sm text-gray-700 items-center">
        {props.message}
      </span>

      {type}
    </li>
  )
}

export default Action
